import type { Filters, ResultItem as ResultItemType } from '@/domain';
import { PaginationWrapper } from '../pagination/PaginationWrapper';
import { ResultItem } from '../resultItem/ResultItem';
import { SkeletonResultList } from '../skeletonResultList/SkeletonResultList';

type ResultListMapProps = {
    stats: Record<string, unknown>;
    filters: Filters;
    onFilterChanged: (filters: Filters) => void;
    numberOfPreloadedImages: number;
    results: ResultItemType[] | false;
    loginId?: number;
};

export const ResultListMap = ({ results, filters, numberOfPreloadedImages, loginId, stats, onFilterChanged }: ResultListMapProps) => {
    const renderItemNodes = () =>
        ((results ?? []) as ResultItemType[]).map((item, index) => (
            <ResultItem
                key={item.id}
                rank={index}
                item={item}
                filters={filters}
                imagePreloaded={index < numberOfPreloadedImages}
                loginId={loginId}
            />
        ));

    const renderItemsAndPagination = () => (
        <>
            <section className="grid grid-cols-2 gap-8 p-16" aria-labelledby="ads-heading" id="ads" data-testid="resultList">
                <h1 className="sr-only" id="ads-heading">
                    Søkeresultater
                </h1>
                {renderItemNodes()}
            </section>
            <PaginationWrapper stats={stats} onFilterChanged={onFilterChanged} />
        </>
    );

    const renderFetchFailedMessage = () => (
        <p className="p-16 text-22 font-bold text-center" data-testid="fetchFailed">
            {/* biome-ignore lint/a11y/useValidAnchor: This existed before biome was added */}
            Noe gikk galt under henting av tilbud. <a href="">Prøv å laste siden på nytt</a>.
        </p>
    );

    const renderNoResultsMessage = () => (
        <p className="p-16 text-22 font-bold text-center" data-testid="emptyResultList">
            Ingen treff akkurat nå. Zoom ut i kartet for å få flere treff.
        </p>
    );

    if (results === null) {
        return <SkeletonResultList />;
    }
    if (results === false) {
        return renderFetchFailedMessage();
    }
    if (results.length === 0) {
        return renderNoResultsMessage();
    }
    return renderItemsAndPagination();
};
